<template>
    <div ref="choose_broker" class="choose-broker">
        <h2 class="mb-3">{{ $t('tradingAcc') }}</h2>
        <p>{{ $t('chooseAcc') }}</p>
        <div v-if="brokers.length > 0" class="headers">
            <p v-for="header in headersToShow" :key="header" class="header-value">{{ header }}</p>
        </div>
        <div v-if="brokers.length > 0" class="cards-container">
            <div @click="setCurrentBroker(broker), setNextBtnDisabled(false)" v-for="(broker, i) in brokersToShow"
                :key="broker.id" :class="'broker-card ' + (currentBroker == broker ? 'selected' : '')">
                <span class="info-broker" v-for="info in infoToShow" :key="'broker-card-' + i + '-' + info.value">
                    <Fragment v-if="info.type == 'text'">
                        {{ info.value == 'broker.name' ? broker.broker.name : broker[info.value] }}
                    </Fragment>
                    <Fragment v-else>
                        <Fragment v-if="info.value == 'verified'">
                            <img class="broker-icon" v-if="broker[info.value]" src="@/assets/icons/Audited.svg"
                                alt="audited-logo">
                            <img class="broker-icon" v-else src="@/assets/icons/noAudited.svg" alt="audited-logo">
                        </Fragment>
                        <Fragment v-if="info.value == 'automated'">
                            <img class="broker-icon" v-if="broker[info.value]" src="@/assets/icons/AutoSync.svg"
                                alt="audited-logo">
                            <img class="broker-icon" v-else src="@/assets/icons/noauto-sync.svg" alt="audited-logo">
                        </Fragment>
                    </Fragment>
                </span>
            </div>
        </div>
        <div v-if="brokers.length <= 0" class="no-results-container">
            <p class="no-brokers-availabe">{{ $t("noBrokersAvailable") }}</p>
            <button class="go-to-profile__btn" @click="$router.push({ name: 'profile' })">{{ $t("checkAccounts") }}</button>
        </div>
        <span v-if="showMoreAcc" class="more-acc-btn" @click="increaseIndexToShow()">{{ $t('moreAcc') }}</span>
    </div>
</template>

<script>
export default {
    props: {
        currentBroker: Object,
        setCurrentBroker: Function,
        stepActive: Boolean,
        setNextBtnDisabled: Function
    },
    watch: {
        stepActive: function () {
            if (this.stepActive) {
                this.$refs.choose_broker.style.width = "100%";
                this.$refs.choose_broker.style.height = "100%";
                if (!this.currentBroker) {
                    this.setNextBtnDisabled(true);
                } else {
                    this.setNextBtnDisabled(false);
                }
                return;
            }
            this.$refs.choose_broker.style.width = "0";
            this.$refs.choose_broker.style.height = "0";
        },
        currentIndex: function () {
            this.brokersToShow = this.brokers.slice(0, this.currentIndex);
        }
    },
    data: function () {
        return {
            brokers: [],
            brokersToShow: [],
            headersToShow: [this.$t('headers_ChooseBroker.brokerName'), this.$t('headers_ChooseBroker.accountId'), this.$t('headers_ChooseBroker.accountType'), this.$t('headers_ChooseBroker.currency'), this.$t('headers_ChooseBroker.autoSync'), this.$t('headers_ChooseBroker.audited')],
            infoToShow: [{ value: 'broker.name', type: 'text' }, { value: 'identifier', type: 'text' }, { value: 'type', type: 'text' }, { value: 'currency', type: 'text' }, { value: 'automated', type: 'icon' }, { value: 'verified', type: 'icon' }],
            currentIndex: 0,
            showMoreAcc: false
        }
    },
    mounted() {
        this.setBrokers();
    },
    methods: {
        setBrokers() {
            this.brokers = this.$store.state.user.brokerAccounts.filter(acc => acc.verified == true);
            if (this.brokers.length > 4) {
                this.showMoreAcc = true;
            }
            this.currentIndex = 4;
        },
        increaseIndexToShow() {
            this.currentIndex += 4;
            if (this.currentIndex > this.brokers.length) {
                this.currentIndex = this.brokers.length - 1;
                this.showMoreAcc = false;
            }
        }
    }
}
</script>

<style lang="scss">
.choose-broker {
    display: flex;
    flex-direction: column;
    font-family: "Avenir", sans-serif;
    width: 0;
    height: 0;
    overflow: hidden;
    transition: width 0.09s ease-in-out;

    h6 {
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 10px;
        font-family: "Avenir", sans-serif;
    }

    p {
        font-size: 16px;
        margin-bottom: 40px;
        font-family: "Avenir", sans-serif;
    }

    .headers {
        display: flex;
        flex-direction: row;
        padding: 10px 30px;
        margin-bottom: 40px;
        width: 100%;

        .header-value {
            font-size: 16px;
            font-weight: bold;
            margin: auto;
            width: 110px;
            text-align: center;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }

    .cards-container {
        display: flex;
        flex-direction: column;
        width: 100%;

        .broker-card {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            padding: 18px 30px;
            background: var(--v-cardBackground-base);
            border-radius: 10px;
            box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.05);
            margin-bottom: 40px;
            border: 1px solid transparent;
            height: 100px;

            .info-broker {
                font-size: 16px;
                margin: auto;
                width: 110px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                white-space: initial;
                -webkit-box-orient: vertical;
                text-align: center;

                img {
                    width: 25px;
                    height: 25px;

                }

                &:last-of-type {
                    margin-right: 0;
                }
            }

            &.selected {
                border: 1px solid var(--v-mainGreen-base);
                cursor: pointer;
                box-shadow: none;
            }

            &:hover {
                border: 1px solid #9A9A9A;
                box-shadow: none;
                cursor: pointer;
            }
        }
    }

    .more-acc-btn {
        text-decoration: underline;
        color: var(--v-mainGreen-base);
        font-size: 14px;
        display: flex;
        margin-left: auto;
        margin-right: 20px;

        &:hover {
            cursor: pointer;
        }
    }

    .no-results-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: auto;

        .no-brokers-availabe {
            font-size: 18px;
            text-align: start;
            margin-bottom: 20px;
        }

        .go-to-profile__btn {
            color: var(--v-mainBlack-base);
            background: var(--v-mainGreen-base);
            padding: 10px 16px;
            border-radius: 10px;
            border: 1px solid transparent;
            min-width: 100px;

            @media (max-width: 768px) {
                width: calc(100% - 32px);
            }
        }
    }
}
</style>